<form [formGroup]="form">
  <div>
    <mat-form-field class="field" [floatLabel]="'always'">
      <mat-label>{{ 'provider'| human }}</mat-label>
      <input type="text"
              placeholder="Buscar {{ 'provider' | human }}"
              aria-label="Buscar proveedor"
              matInput
              formControlName="document_id"
              [matAutocomplete]="autoDocument"
      >
      @if (loading()) {
        <span matTextPrefix>
          <mat-spinner diameter="15"></mat-spinner>
        </span>
      }
      <mat-autocomplete #autoDocument="matAutocomplete" [displayWith]="displayFn">
        @for(document of documents(); track document.id) {
          <mat-option [value]="document">
            <div class="option-wrapper">
              <div class="option-left">
                <span><b>{{ document.name }}</b></span>
                <span class="option-field">{{'rut' | human}}: {{ document.rut | identifier}}</span>
              </div>
            </div>
          </mat-option>
        }
      </mat-autocomplete>
      <button
          type="button"
          class="icon-success"
          mat-icon-button
          matSuffix
          go-to-create
          elementType="Provider"
          (afterClosed)="onCreate($event)"
          matTooltip="Agregar Nuevo {{'provider' | human | titlecase }}"
      >
        <mat-icon>add_box</mat-icon>
      </button>
    </mat-form-field>
  </div>
</form>
